// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--r3hJM","info":"_02712f2b3b--info--mywqS","link":"_02712f2b3b--link--GGXmT"};